



































































































import { namespace } from 'vuex-class';
import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  CART,
  DETAIL
} from '@/store/types';
import { ConfigService } from '@/services/ConfigService';
import {
  PriceDto,
  PriceTypeDto,
  ProductAttributeInfo,
  ProductBasePrice,
  ProductNetFillQuantity,
  SalesConditionInfo
} from '@eurogast/hub-client-typescript';
import { NumberFormatter } from '@/services/NumberFormatter';
import { Cart } from '@/services/cart/model/cart';
import { UnitDefinition } from '@/services/ProductDeserializer';
import Nara from '@/domain/product/Nara';
import NaraIcons from '@/search-result/badges/NaraIcons.vue';
import FairPriceIcon from '@/search-result/badges/FairPriceIcon.vue';
import ProductAttributeBadges from '@/search-result/badges/ProductAttributeBadges.vue';
import VirtualCategoryBadges from '@/search-result/badges/VirtualCategoryBadges.vue';

const cart = namespace(CART);
const detail = namespace(DETAIL);
@Component({
  components: {
    VirtualCategoryBadges,
    ProductAttributeBadges,
    FairPriceIcon,
    NaraIcons
  }
})
export default class ProductProperties extends Vue {

  get currentBasePrice() {
    return NumberFormatter.formatBasePriceString(this.basePrice, this.price, null);
  }

  get currentUVPPrice() {
    return NumberFormatter.formatUVPPriceString(this.productStorageUnit, this.price);
  }

  get isPromotion() {
    return this.price && this.price.type === PriceTypeDto.PROMOTION;
  }

  get isSpecial() {
    return this.price && this.price.type === PriceTypeDto.SPECIAL;
  }

  get hasDiscount(): boolean {
    return !!(this.price && this.price.attachedDiscount) &&
      ConfigService.isHighlightDiscounts();
  }

  get naras(): Nara[] {
    return Nara.parseNarasJson(this.localNaras);
  }

  @cart.State('cart')
  public cart: Cart;

  @detail.State('price')
  public price: PriceDto;

  @Prop({ required: true })
  public localSku: string;
  @Prop()
  public localNetFillQuantity: string;
  @Prop()
  public localBasePrice: string;
  @Prop()
  public localProductAttributes: string;
  @Prop()
  public localVirtualCategories: string;
  @Prop()
  public localProductConditions: string;
  @Prop()
  public localProductUnits: string;
  @Prop({ required: false, default: () => [] })
  public localNaras: string;

  public isLoggedIn: boolean = ConfigService.isLoggedIn();

  private netFillQuantity: ProductNetFillQuantity = null;
  private basePrice: ProductBasePrice = null;
  private productStorageUnit: UnitDefinition = null;
  private productAttributes: ProductAttributeInfo[] = [];
  private virtualCategories: string[] = [];
  private productConditions: SalesConditionInfo[] = [];

  public mounted() {
    if (this.localNetFillQuantity) {
      this.netFillQuantity = ConfigService.parseNetFillQuantity(this.localNetFillQuantity);
    }
    if (this.localBasePrice) {
      this.basePrice = ConfigService.parseBasePrice(this.localBasePrice);
    }
    if (this.localProductAttributes) {
      this.productAttributes = ConfigService.parseAttributes(this.localProductAttributes);
    }
    if (this.localVirtualCategories) {
      this.virtualCategories = ConfigService.parseArray(this.localVirtualCategories);
    }
    if (this.localProductConditions) {
      this.productConditions = ConfigService.parseSalesConditions(this.localProductConditions);
    }
    if (this.localProductUnits) {
      this.productStorageUnit = ConfigService.parseUnits(this.localProductUnits).filter((u) => u.isStorageUnit)[0];
    }
  }

  private formatDate(date: string) {
    const priceDate = new Date(date);
    return priceDate.toLocaleDateString('de-AT');
  }

  private getNetFillQuantityString() {
    return this.netFillQuantity && this.netFillQuantity.unit
      ? NumberFormatter.formatFillQuantity(this.netFillQuantity.quantity)
      + this.netFillQuantity.unit.toString() : '';
  }
}
